const normalizeUnicode = (value = '') => {
  const stringValue = String(value);
  try {
    return stringValue.normalize('NFKC');
  } catch (_) {
    return stringValue;
  }
};

const normalizePunctuation = (value = '') =>
  String(value)
    .replace(/[‘’]/g, "'")
    .replace(/[“”]/g, '"')
    .replace(/[‐‑–—]/g, '-')
    .replace(/\u00A0/g, ' ');

const normalizeTemplatePlaceholders = (value = '') =>
  String(value).replace(
    /\{\{\s*([^{}]+?)\s*\}\}|\$\{\s*([^{}]+?)\s*\}|\{\s*([^{}]+?)\s*\}/g,
    (_, mustacheValue, dollarValue, braceValue) => {
      const rawToken = mustacheValue || dollarValue || braceValue || '';
      const normalizedToken = String(rawToken).trim().toLowerCase();
      return `{${normalizedToken}}`;
    }
  );

export const normalizeTranslationTemplate = (value = '') => {
  const unicodeNormalized = normalizeUnicode(value);
  const punctuationNormalized = normalizePunctuation(unicodeNormalized);
  const placeholderNormalized = normalizeTemplatePlaceholders(punctuationNormalized);
  return placeholderNormalized.replace(/\s+/g, ' ').trim();
};

export const normalizeTranslationKey = (value = '') =>
  normalizeTranslationTemplate(value).toLowerCase();

export const buildSearchableKeyVariants = (value = '') => {
  const normalizedValue = normalizeTranslationKey(value);
  if (!normalizedValue) {
    return [];
  }

  const tokenizedValue = normalizedValue.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
  const punctuationAgnosticValue = tokenizedValue
    .replace(/[,:;.!?()[\]"]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const compactValue = punctuationAgnosticValue.replace(/\s+/g, '');

  return Array.from(
    new Set([
      normalizedValue,
      tokenizedValue,
      punctuationAgnosticValue,
      tokenizedValue.replace(/\s+/g, '-'),
      tokenizedValue.replace(/\s+/g, '_'),
      compactValue,
    ]).values()
  );
};
